import { useEffect } from 'react';

/**
 * Marca una pantalla como `noindex` mientras está abierta, y lo quita al salir.
 *
 * Va en las tres de consulta. `robots.txt` ya las desautoriza, pero un buscador que llegue por un
 * enlace compartido no lo lee antes de indexar: la etiqueta es la que de verdad lo impide. Y no es
 * cosmética, es dinero: cada consulta cuesta, y un rastreador recorriendo `/preguntar` con cien
 * variantes se come el tope de gasto de la hora y deja a las personas sin servicio.
 */
export function useNoIndex(activo: boolean): void {
  useEffect(() => {
    if (!activo) return;
    const etiqueta = document.createElement('meta');
    etiqueta.name = 'robots';
    etiqueta.content = 'noindex, nofollow';
    document.head.appendChild(etiqueta);
    return () => {
      etiqueta.remove();
    };
  }, [activo]);
}
